import PropTypes from 'prop-types'
import { Card, CardContent, CardHeader, Skeleton, Stack, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Chart } from 'src/components/chart'

/** garment 種別 / 決済方法など、少数カテゴリの内訳をドーナツで見せる */
const useChartOptions = (labels) => {
  const theme = useTheme()

  return {
    chart: { background: 'transparent', toolbar: { show: false } },
    colors: [
      theme.palette.primary.main,
      theme.palette.success.main,
      theme.palette.warning.main,
      theme.palette.info.main,
      theme.palette.error.main,
    ],
    dataLabels: { enabled: true, formatter: (val) => `${Math.round(val)}%` },
    labels,
    legend: { show: true, position: 'bottom' },
    plotOptions: { pie: { donut: { size: '60%' } } },
    states: { active: { filter: { type: 'none' } }, hover: { filter: { type: 'none' } } },
    stroke: { width: 0 },
    theme: { mode: theme.palette.mode },
    tooltip: { y: { formatter: (v) => `${v.toLocaleString()} 件` } },
  }
}

export const PatternDonutChart = (props) => {
  const { items = [], loading = false, subheader, title } = props

  const labels = items.map((i) => i.label)
  const options = useChartOptions(labels)
  const series = items.map((i) => i.count)
  const isEmpty = series.length === 0 || series.every((v) => v === 0)

  return (
    <Card sx={{ height: '100%' }}>
      <CardHeader title={title} subheader={subheader} />
      <CardContent>
        {loading ? (
          <Skeleton variant="rectangular" height={280} />
        ) : isEmpty ? (
          <Stack alignItems="center" justifyContent="center" sx={{ height: 280 }}>
            <Typography color="text.secondary" variant="body2">
              この期間のデータがありません
            </Typography>
          </Stack>
        ) : (
          <Chart height={280} options={options} series={series} type="donut" width="100%" />
        )}
      </CardContent>
    </Card>
  )
}

PatternDonutChart.propTypes = {
  items: PropTypes.array,
  loading: PropTypes.bool,
  subheader: PropTypes.string,
  title: PropTypes.string.isRequired,
}
